/**
 * src/components/analytics/PageViewEvent.tsx
 *
 * Generic GA4 page-level event emitter — Client Component, mount'ta `trackEvent`
 * çağırır. Hizmet detayda `view_item`, blog detayda `view_article` gibi
 * sayfa-spesifik conversion event'leri için kullanılır.
 *
 * Neden mount'ta? GA4 otomatik `page_view` event'i zaten gönderir; bu component
 * sayfa-spesifik ek event (item/article metadata) gönderir. Consent öncesi gtag
 * yüklenmediği için trackEvent no-op olur — güvenli.
 *
 * Kullanım:
 *   <PageViewEvent name="view_item" params={{ item_id, item_name, item_category }} />
 *
 * Sadece bir kez çağrılır (mount'ta); StrictMode double-effect koruması var.
 */
'use client'

import { useEffect, useRef } from 'react'

import { trackEvent, type GtagParams } from '@/lib/analytics/gtag'

interface PageViewEventProps {
  name: string
  params?: GtagParams
}

export function PageViewEvent({ name, params }: PageViewEventProps) {
  // StrictMode double-mount koruması — event yalnız 1 kez gönderilir.
  const sentRef = useRef(false)

  useEffect(() => {
    if (sentRef.current) return
    sentRef.current = true
    trackEvent(name, params)
    // params reference stable değilse de bir kez gönder; deps boş [].
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
